import { render, staticRenderFns } from "./gravity-left.vue?vue&type=template&id=08b7cb56&"
import script from "./gravity-left.vue?vue&type=script&lang=js&"
export * from "./gravity-left.vue?vue&type=script&lang=js&"
import style0 from "./gravity-left.vue?vue&type=style&index=0&id=08b7cb56&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports